import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiSearch, FiCode, FiUser, FiLogOut } from 'react-icons/fi';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/config';
import ThemeToggle from './ThemeToggle';

const Header = ({ user, onMenuToggle }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-toggle" onClick={onMenuToggle}>
          <FiMenu />
        </button>
        <Link to="/" className="logo">
          <FiCode className="logo-icon" />
          <span>JustDoCode</span>
        </Link>
      </div>
      
      <div className="header-right">
        <div className="search-bar">
          <FiSearch />
          <input 
            type="text" 
            placeholder="Search topics..." 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        
        <ThemeToggle />
        
        {user ? (
          <div className="user-menu">
            <Link to="/profile" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: 'inherit' }}>
              <div className="user-avatar">
                {user.email?.charAt(0).toUpperCase() || 'U'}
              </div>
              <span>{user.displayName || user.email?.split('@')[0]}</span>
            </Link>
            <button onClick={handleLogout} className="btn btn-secondary" style={{ marginLeft: '8px' }}>
              <FiLogOut /> Logout
            </button>
          </div>
        ) : null}
      </div>
    </header>
  );
};

export default Header;

